/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Информация о грузе в виде общего веса и объема
 */
export type OrderDeliveryInfoCargoTotal = {
  /**
   * Тип посылки
   */
  type: OrderDeliveryInfoCargoTotal.type
  /**
   * Общий вес груза (в г)
   */
  weight: number
  /**
   * Общий объем груза (в м3)
   */
  volume: number
  /**
   * Количество грузомест в грузе (по умолчанию равно 1)
   */
  amount?: number
}
export namespace OrderDeliveryInfoCargoTotal {
  /**
   * Тип посылки
   */
  export enum type {
    CUSTOM = 'custom'
  }
}
